import { Service } from "./service"
export * from "./types"

export const StockDocumentService = Service




// WEBPACK FOOTER //
// ./src/state/inventory/stockdocument/services/index.ts